export default {
  updatedData: state => state.updatedData,
  updatedUnityData: state => state.updatedUnityData,
  programmerComments: state => state.programmerComments,
}
